<template>
  <Popup :showTitle="false" :closeable="false" minHeight="100%" ref="popup">
    <van-search
      v-model="word"
      show-action
      placeholder="请输入搜索关键词"
      clearable
      autofocus
      @search="onSearch"
      @cancel="popup.show = false"
    />
    <Content :top="54" :bottom="0">
      <Loading
        v-if="showLoading"
        :isLoading="isLoading"
        @reload="getDataLoading"
      />
      <ul v-if="list.length" class="code-list">
        <li v-for="item in list" :key="item.userId" class="code-list-item">
          <div class="code-list-item__title">{{ item.companyName }}</div>
          <van-button @click="$router.push(`/userInfo/${item.userId}`)"
            >详细</van-button
          >
        </li>
      </ul>
      <Empty
        v-else
        :description="
          searchWord ? `没有找到与‘${searchWord}’的相关信息` : '请搜索用户'
        "
      />
    </Content>
  </Popup>
</template>

<script>
import { Toast } from 'vant'
import { queryCustomerList } from '@/api/customer'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { reactive, ref, watch } from 'vue'
export default {
  name: 'Search',
  setup() {
    const popup = ref(null)
    const word = ref('')
    const params = reactive({
      userName: word
    })
    const showPopup = () => {
      popup.value.show = true
    }
    const list = ref([])
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(
      queryCustomerList,
      data => {
        list.value = data
      },
      params
    )
    const searchWord = ref('')
    watch(word, () => {
      if (word.value === '') {
        searchWord.value = ''
      }
    })
    const onSearch = value => {
      if (word.value) {
        searchWord.value = value
        getDataLoading()
      } else {
        Toast('请输入客户名称')
      }
    }
    return {
      popup,
      showPopup,
      word,
      showLoading,
      isLoading,
      getDataLoading,
      onSearch,
      searchWord,
      list
    }
  }
}
</script>

<style lang="scss" scoped>
.code-list {
  padding: 16px 16px 0 16px;
  .code-list-item {
    padding: 10px 16px;
    font-size: 16px;
    background-color: #fff;
    display: flex;
    align-items: center;
    box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px,
      rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
    margin-bottom: 16px;
    color: #666;
    &__title {
      flex: 1;
      margin-right: 10px;
    }
  }
}
</style>
